module.exports = __webpack_public_path__ + "img/picture_s2examinationvideo2@2x.5a5aa454.png";